import { render } from "./DataServicesEditView.vue?vue&type=template&id=c0f8f1a0"
import script from "./DataServicesEditView.vue?vue&type=script&lang=js"
export * from "./DataServicesEditView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/pierre_josselin/Documents/GitHub/ouranos-ws-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__